/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import { CourierPackage, CourierPackageFromJSON, CourierPackageToJSON } from './CourierPackage';
/**
 * 
 * @export
 * @interface RewardTransaction
 */
export interface RewardTransaction {
    /**
     * 
     * @type {string}
     * @memberof RewardTransaction
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof RewardTransaction
     */
    points?: number;
    /**
     * 
     * @type {Date}
     * @memberof RewardTransaction
     */
    createdOn?: Date;
    /**
     * Money value of the points moved by this transaction, at the rate in force when written.
     * @type {number}
     * @memberof RewardTransaction
     */
    pointsValue?: number;
    /**
     * Invoice this redemption paid for, when the transaction came from a POS checkout.
     * @type {number}
     * @memberof RewardTransaction
     */
    invoiceId?: number;
    /**
     * 
     * @type {number}
     * @memberof RewardTransaction
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof RewardTransaction
     */
    courierUserId?: number;
    /**
     * 
     * @type {number}
     * @memberof RewardTransaction
     */
    courierId?: number;
    /**
     * 
     * @type {number}
     * @memberof RewardTransaction
     */
    courierPackageId?: number;
    /**
     * 
     * @type {CourierPackage}
     * @memberof RewardTransaction
     */
    courierPackage?: Partial<CourierPackage>;
}

/**
 * Check if a given object implements the RewardTransaction interface.
 */
export function instanceOfRewardTransaction(value: object): value is RewardTransaction {
    return true;
}

export function RewardTransactionFromJSON(json: any): RewardTransaction {
    return RewardTransactionFromJSONTyped(json, false);
}

export function RewardTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardTransaction {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'points': json['points'] == null ? undefined : json['points'],
        'createdOn': json['createdOn'] == null ? undefined : (new Date(json['createdOn'])),
        'pointsValue': json['pointsValue'] == null ? undefined : json['pointsValue'],
        'invoiceId': json['invoiceId'] == null ? undefined : json['invoiceId'],
        'id': json['id'] == null ? undefined : json['id'],
        'courierUserId': json['courierUserId'] == null ? undefined : json['courierUserId'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
        'courierPackageId': json['courierPackageId'] == null ? undefined : json['courierPackageId'],
        'courierPackage': json['courierPackage'] == null ? undefined : CourierPackageFromJSON(json['courierPackage']),
    };
}

export function RewardTransactionToJSON(json: any): RewardTransaction {
    return RewardTransactionToJSONTyped(json, false);
}

export function RewardTransactionToJSONTyped(value?: RewardTransaction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'points': value['points'],
        'createdOn': value['createdOn'] == null ? undefined : ((value['createdOn']).toISOString()),
        'pointsValue': value['pointsValue'],
        'invoiceId': value['invoiceId'],
        'id': value['id'],
        'courierUserId': value['courierUserId'],
        'courierId': value['courierId'],
        'courierPackageId': value['courierPackageId'],
        'courierPackage': value['courierPackage'] == null ? undefined : CourierPackageToJSON(value['courierPackage']),
    };
}

